
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/goireland",
      function () {
        return require("private-next-pages/case-study/goireland.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/goireland"])
      });
    }
  